
import axios from 'axios';

import env_vars from '@/data/env_vars.json'; // Adjust the path if necessary


export const BASE_URL = env_vars?.API_BACKEND_URL+'/api/infraq'

//functions to talk to backend
export const handleError = (error:any) => {
  if (error.response) {
      console.log(error.response)
      if (error.response.status === 401) {
          alert("Error: Not Authenticated");
      } else if (error.response.status === 404) {
          alert("Error: Resource not found");
      } else if (error.response.status === 400) {
          if(error.response?.data?.detail){
              alert("Error: "+error.response.data.detail);
          }
      } else {
          alert('Error occurred');
      }
      console.error('Error sending data:', error.response.data);
  } else {
      if(error?.message){
          if(error.message=="Network Error"){
              alert("Backend Error")
          }

      }
      else{
          alert('An unexpected error occurred');

      }
      console.error('Error sending data:', error.message);
  }
};



//functions to talk to backend
export const handleDisplayError = (error:any) => {
    if (error.response) {
        console.log(error.response)
        if (error.response.status === 401) {
            console.log("Error: Not Authenticated")
            return "Error: Not Authenticated";
        } else if (error.response.status === 404) {
            console.log("Error: Resource not found")
            return "Error: Resource not found";
        } else if (error.response.status === 400 && error.response?.data?.detail) {
            console.log("Error: "+error.response.data.detail)
            return "Error: "+error.response.data.detail;
        } else {
            console.log('Error occurred')
            return 'Error:' + error.response?.data;
        }
    } else {
        if(error?.message){
            if(error.message=="Network Error"){
                console.log("Backend Error")
                return "Backend Error";
            }
        }
        else{
            console.log('An unexpected error occurred')
            return 'An unexpected error occurred';
  
        }
        console.log('Error sending data:' + error.message)
        return 'Error sending data:' + error.message;
    }
  };


export const createApiClient = (displayError:boolean = false) => {
  const token = localStorage.getItem('jwt-token');
  if (!token) {
        if(displayError){
            console.log("Not Authenticated")
            return null
        }
        alert("Not Authenticated");
        return null;
  }

  return axios.create({
      baseURL: BASE_URL,
      headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
      },
  });
};

export const apiRequest = (method: string) => async (url: string, data?: any, displayError:boolean = false) => {
  const apiClient:any = createApiClient(displayError);
  if (!apiClient) return null;

  try {
      const response = await apiClient[method](url, data);
      return response.data;
  } catch (error) {
      if(displayError){
        return {
            "plorusError": handleDisplayError(error)
        }
      }
      else{
        handleError(error);
      }
      return null;
  }
};